import { notificationsListingRoutes } from './features/notifications-listing/notifications-listing.routes';
import { notificationsUserRoutes } from './features/notifications-user/notifications-user.routes';

export const notificationsRoutes = [
  {
    path: '/notifications',
    name: 'notifications',
    meta: {
      requiresAuth: true // all app paths require authentication
    },
    component: () => import(/* webpackChunkName: "notifications" */ './Notifications.vue'),
    children: [...notificationsListingRoutes, ...notificationsUserRoutes]
  }
];
